import React from 'react';
import ReactDOM from 'react-dom/client';
import Modal from '@/components/modal';
import '@/utils/init';
import { checkUser } from '@/utils/check-user';
import { enablePublicLoginEntry } from '@/apis/organizationContext';

enablePublicLoginEntry();

const DefaultPage = () => {
  return <Modal/>;
};

const render = () => {

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  root.render(
    <React.Suspense>
      <DefaultPage/>
    </React.Suspense>
  );
};


checkUser().then((r) => {
  if (r) {
    render();
  }
}).catch(() => {
  render();
});
